import { defineComponent as _defineComponent } from 'vue';
import { useSettingsStore } from '@/store/modules/settings';
import { translate } from '@/i18n';
import { getList } from '@/api/notice';

import { inject, ref, nextTick } from 'vue';
import { storeToRefs } from 'pinia';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const $baseMessage = inject('$baseMessage');
    const settingsStore = useSettingsStore();
    const {
      theme
    } = storeToRefs(settingsStore);
    const activeName = ref('notice');
    const notices = ref([]);
    const badge = ref(undefined);
    const fetchData = async () => {
      const {
        data: {
          list,
          total
        }
      } = await getList();
      notices.value = list;
      badge.value = total === 0 ? undefined : total;
    };
    nextTick(() => {
      if (theme.value.showNotice) fetchData();
    });
    const handleClick = () => {
      fetchData();
    };
    const handleClearNotice = () => {
      badge.value = undefined;
      notices.value = [];
      $baseMessage('清空消息成功', 'success', 'vab-hey-message-success');
    };
    const formatTime = time => {
      const date = new Date(time);
      const now = new Date();
      const diff = now.getTime() - date.getTime();
      const minutes = Math.floor(diff / 60000);
      const hours = Math.floor(diff / 3600000);
      const days = Math.floor(diff / 86400000);
      if (minutes < 1) return '刚刚';
      if (minutes < 60) return `${minutes}分钟前`;
      if (hours < 24) return `${hours}小时前`;
      if (days < 7) return `${days}天前`;
      return date.toLocaleDateString();
    };
    const __returned__ = {
      $baseMessage,
      settingsStore,
      theme,
      activeName,
      notices,
      badge,
      fetchData,
      handleClick,
      handleClearNotice,
      formatTime,
      get translate() {
        return translate;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
});